import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';

import { Markdown } from 'components';
import InfoIcon from 'assets/images/benefits/outpatients/info-icon.svg';

import { NoteModal } from './components';

export const ImportantNotesButton = (): JSX.Element => {
  const { t } = useTranslation();
  const [isImportantNotesModalVisible, setIsImportantNotesModal] = useState(false);

  const showImportantNotesModal = () => setIsImportantNotesModal(true);
  const closeImportantNotesModal = () => setIsImportantNotesModal(false);

  return (
    <>
      <Button icon={<img src={InfoIcon} alt="info-icon" />} onClick={showImportantNotesModal}>
        {t('benefits.disclaimer')}
      </Button>

      <NoteModal
        title={t('benefits.disclaimer')}
        open={isImportantNotesModalVisible}
        okText={t('common.ok')}
        onOk={closeImportantNotesModal}
        onCancel={closeImportantNotesModal}
      >
        <Markdown>{t('cms.benefits.coverage.disclaimer.content')}</Markdown>
      </NoteModal>
    </>
  );
};
